// test343
(343 && 0);
